import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ReportUtil } from './util/reports.util';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Paciente } from 'src/app/models/licitacao/paciente.model';
import { AuthService } from 'src/app/services/vos/auth.service';
import { ReportsService } from 'src/app/services/vos/reports.service';
import { ModalViewReportComponent } from './modal-view-report/modal-view-report.component';

@Component({
  selector: 'app-meus-relatorios',
  templateUrl: './meus-relatorios.component.html',
  styleUrls: ['./meus-relatorios.component.css']
})
export class MeusRelatoriosComponent implements OnInit {

  relatorios: any[] = [];
  user: any = [];
  loading: boolean = false;

  inscricao: Subscription;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private authService: AuthService,
    private reportsService: ReportsService,
    public reportUtil: ReportUtil
  ) { }

  ngOnInit(): void {
    this.getUser();
    this.getReports();
  }

  getUser() {
    this.user = JSON.parse(this.authService.getUserLoggedIn());
  }

  getReports() {
    this.loading = true;
    this.inscricao = this.reportsService.relatoriosprestador(this.user.user.pessoa.prestador.id).subscribe((res) => {
      this.relatorios = res
      this.loading = false;

    })
  }

  openDialog(item?) {
    this.dialog.open(ModalViewReportComponent, {
      data: item,
      width: '80%'
    }).afterClosed().subscribe((result) => {});
  }

  createReport() {
    this.router.navigate(['main/supplier-reports/create']);
  }

  ngOnDestroy() {
    if(this.inscricao) this.inscricao.unsubscribe();
  }

}
